<!-- {{form.get(field).errors | json}} -->

<ng-container *ngIf="form && form.get(field) && form.get(field).touched">
	<ng-container *ngFor="let error of form.get(field).errors | keyvalue">
		<div class="invalid-feedback {{field}} {{error.key}}" *ngIf="error.key !== 'required'">
			<i class="fas fa-exclamation-triangle" aria-hidden="true"></i> <span [innerHtml]="getErrorMessage(error.key)"></span>
		</div>
	</ng-container>
</ng-container>